<div class="startbar">
  <app-logo-box />

  <div class="startbar-menu">
    <ngx-simplebar class="startbar-collapse" id="startbarCollapse">
      <div class="startbar-wrapper">
        <ul class="navbar-nav startbar-nav">
          @for (item of menuItems; track $index; let first = $first) {
          @if (item.isTitle) {
          <li [ngClass]="first ? 'menu-label menu-label--first' : 'menu-label menu-label--rest'">
            @if (!first) {
            <small class="label-border">
              <div class="border_left border_left--responsive"></div>
              <div class="border_right"></div>
            </small>
            <span>{{ item.label }}</span>
            } @else {
            <span>{{ item.label }}</span>
            }
          </li>
          } @else if (!visivelPeloPapel(item)) {
          <!-- sem permissão no papel da lista selecionada -->
          } @else if (hasSubmenu(item)) {
          <ng-container *ngTemplateOutlet="MenuItemWithChildren;context: {menu: item,}">
          </ng-container>
          } @else {
          <ng-container *ngTemplateOutlet="MenuItem;context: {menu: item,}">
          </ng-container>
          }
          }
        </ul>
        <div class="update-msg">
          <a [href]="manual.url" target="_blank" rel="noopener noreferrer" class="update-msg__icon-link thumb-lg update-icon-box" aria-label="Abrir manual em nova aba">
            <i class="fas fa-book update-msg__icon"></i>
          </a>
          <h5 class="update-msg__title">Manual</h5>
          <a [href]="manualUsuario.url" target="_blank" rel="noopener noreferrer" class="btn update-msg__btn update-msg__btn--novo">
            {{ manualUsuario.rotulo }}
          </a>
          <p class="update-msg__text update-msg__text--novo">Versão: {{ manualUsuario.versao }}</p>
        </div>
      </div>
    </ngx-simplebar>
  </div>
</div>
<div class="startbar-overlay" (click)="overlayClicked.emit()"></div>

<ng-template #MenuItemWithChildren let-menu="menu">
  <li class="nav-item">
    <a class="nav-link" [routerLink]="menu.url" [ngClass]="{ active: activeMenuItems.includes(menu.key) }" data-bs-toggle="collapse" (click)="toggleMenuItem(menu, collapse)" role="button" [attr.aria-expanded]="!menu.collapsed" aria-controls="sidebarDashboards" [attr.aria-controls]="menu.key">
      @if (menu.icon) {
      <i class="{{ menu.icon }} menu-icon"></i>
      }
      <span class="nav-text"> {{ menu.label }} </span>
    </a>
    <div #collapse="ngbCollapse" [(ngbCollapse)]="menu.collapsed" class="collapse" id="sidebarDashboards">
      <ul class="nav nav--sub">
        @for (child of menu.subMenu; track child.label) {
        @if (hasSubmenu(child)) {
        <ng-container *ngTemplateOutlet="MenuItemWithChildren;context: {menu: child,}">
        </ng-container>
        } @else {
        <ng-container *ngTemplateOutlet="MenuItem;context: { menu: child,}"></ng-container>
        }
        }
      </ul>
    </div>
  </li>
</ng-template>

<ng-template #MenuItem let-menu="menu">
  <li class="nav-item" [ngClass]="{ active: activeMenuItems.includes(menu.key), 'nav-item--destaque': menu.destaque }">
    <ng-container *ngTemplateOutlet="MenuItemLink; context: { menu: menu }">
    </ng-container>
  </li>
</ng-template>

<ng-template #MenuItemLink let-menu="menu">
  @if(menu.isExternal){
  <a class="nav-link" target="_blank" [href]="menu.url" (click)="requestMobileNavigationClose()" [ngClass]="{ active: activeMenuItems.includes(menu.key) }" [attr.aria-controls]="menu.key">
    <span class="nav-text">{{ menu.label }}</span>
  </a>
  }@else {
  <a class="nav-link" [routerLink]="menu.url" (click)="requestMobileNavigationClose()" [ngClass]="{ active: activeMenuItems.includes(menu.key) }" [attr.aria-controls]="menu.key">
    @if (menu.icon) {
    <i class="{{ menu.icon }} menu-icon"></i>
    }
    <span class="nav-text">{{ menu.label }}</span>  </a>
  }
</ng-template>
